import { Injectable, signal, WritableSignal } from '@angular/core';
import { interval } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimeTickerService {
  tick: WritableSignal<Date> = signal(new Date());

  startInterval(): void {
    interval(60000).subscribe(() => {
      this.tick.set(new Date());
    });
  }
}
